import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { environment } from 'src/envs/environnement';
 interface ImageData {
    itemImageSrc: string;
    thumbnailImageSrc: string;
  }
@Component({
  selector: 'app-ammazing-gallery',

  templateUrl: './ammazing-gallery.component.html',
  styleUrl: './ammazing-gallery.component.scss'
})
export class AmmazingGalleryComponent implements OnChanges {
    @Input() isMultiple=true
    @Input() styleClassName=""
    @Input() isQrCode=false
    @Input() imgUrls!: string;
    @Input() singleImgUrl!: string;
  images: ImageData[] = [];
  singleImages!: ImageData;
  galleriaResponsiveOptions: any[] = [
    {
        breakpoint: '1024px',
        numVisible: 5
    },
    {
        breakpoint: '960px',
        numVisible: 4
    },
    {
        breakpoint: '768px',
        numVisible: 3
    },
    {
        breakpoint: '560px',
        numVisible: 1
    }
];

    baseUrl=environment.baseUrl
  constructor() {}

  ngOnChanges(): void {
    if(this.isMultiple){
        if (this.imgUrls) {
            const tabs = this.imgUrls.split(";");
            this.images = tabs.map(url => ({

              itemImageSrc:this.baseUrl+"/files/download/"+url.trim(),
              thumbnailImageSrc:this.baseUrl+"/files/download/"+url.trim()


            }));

          }
    }else{
        const safeValue = this.singleImgUrl ? this.singleImgUrl.trim() : '';
        if(this.isQrCode){
            this.singleImages={
                itemImageSrc:this.baseUrl+"/files/download/codeqr/"+safeValue.trim(),
                thumbnailImageSrc:this.baseUrl+"/files/download/codeqr/"+safeValue.trim()
            }
        }else{
            this.singleImages={
                itemImageSrc:this.baseUrl+"/files/download/code/"+safeValue.trim(),
                thumbnailImageSrc:this.baseUrl+"/files/download/code/"+safeValue.trim()
            }
        }


    }

  }

  displayDialog: boolean = false;
ressource!:any
  // Méthode pour ouvrir le PDialog
  openDialog(item:any) {
    this.ressource=item
    this.displayDialog = true;
  }
}
